import { createSlice } from "@reduxjs/toolkit"
import { ToasterInterface } from "../../utils/constants/Interfaces.constants";

const initialState: ToasterInterface = {
    visible: false,
    message: '',
    position: 'top-center',
    title: '',
   
}

const toastSlice = createSlice({
    name: 'toast',
    initialState,
    reducers:  {
        showToast: (state, action) => {
            state.visible = true
            state.message = action.payload
            
        },
        
        setTitle: (state, action) => {
            state.title = action.payload
        },
        setToastPostion: (state, action) => {
            state.position = action.payload
        },
        hideToast: (state) => {
            state.visible = false
            state.message = ''
            state.position = 'top-center'
            state.title = ''
        }
    }
});


export const { hideToast, showToast } = toastSlice.actions
export default toastSlice.reducer